import _ from 'lodash';
import moment from 'moment';
import TagTypes from '../../constants/TagTypes';
import { tags_type_count_$gte } from '../query-helpers';

const timestamp = moment().toISOString(true);

const REQUIRED_FIELDS = {
  firstName: {
    $not: ''
  },
  lastName: {
    $not: ''
  },
  zipCode: {
    $not: ''
  },
  // userExpertises
  ...tags_type_count_$gte(TagTypes.Expertise, 1),
  $or: [
    {
      // both dates are in the future (not yet sleeping)
      $and: [
        { inactiveStartingAt: { $gt: timestamp } },
        { inactiveEndingAt: { $gt: timestamp } },
      ]
    },
    {
      // both dates are in the past (no longer sleeping)
      $and: [
        { inactiveStartingAt: { $lt: timestamp } },
        { inactiveEndingAt: { $lt: timestamp } },
      ]
    }
  ]
}

export default REQUIRED_FIELDS;

export const REQUIRED_EDUCATOR_FIELDS = _.omit(REQUIRED_FIELDS, [
  'tags'
]);

export const REQUIRED_PARTNER_FIELDS = _.omit(REQUIRED_FIELDS, [
  // none
]);
